import {
    Box, TableCell, TextField, Select, MenuItem, Tooltip, IconButton,
    Typography
} from "@mui/material";
import RadioButton from './radio';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import findLabel from './findLabel';
import { useState } from "react";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const sx = {
    textBox: {
        '& .MuiInputBase-root': {
            caretColor: '#0A78CD',
            backgroundColor: '#fff !important',
        },
        '.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #d3d3df',
        },
        '.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #d3d3df',
        },
        '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #0A78CD !important',
        },
    },
    selectBox: {
        '&.MuiInputBase-root': {
            caretColor: '#0A78CD',
            backgroundColor: '#fff !important',
        },
        ".MuiOutlinedInput-notchedOutline": {
            border: `1px solid #d3d3df`,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #d3d3df'
        },
        '&:focus-within .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #0A78CD !important',
        },
    }
}

const SelectionBox = ({ data, onDataChange, TooltipContent }) => {
    const [selectedEIN, setSelectedEIN] = useState(data.userEnteredInformation)
    const [open, setOpen] = useState(false);
    const [openDisable, setOpenDisable] =  useState(false)
    const handleChange = data => {
        onDataChange(data)
    }

    setTimeout(() => {
        setOpenDisable(false)
      }, 3500);

    const handleKeyPress = e => {
        var regex = new RegExp('^[0-9]+$')
        var key = String.fromCharCode(!e.charCode ? e.which : e.charCode)
        if (!regex.test(key)) {
            e.preventDefault()
            return false
        }
    }

    const findDom = () => {
        if (data.isCorrect === null) {
            return (<>
                <Box display='flex' alignItems='center' gap='10px' >
                    <Box>
                        <FontAwesomeIcon fontSize="16px" className="font-weight-bold" icon={faArrowLeftLong} />
                    </Box>
                    <Box>Choose one</Box>
                </Box>
            </>)
        } else if (data.isCorrect) {
            return (<Box>
                <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                    {findLabel(data.label)}
                </Box>
                <Box marginTop="5px" fontSize="16px" fontWeight={400} color="#66668F">
                    {data.publicInformation ? data.publicInformation : 'No data found'}
                    {/* {data.userEnteredInformation || data.publicInformation || 'No data found'} */}
                </Box>
            </Box>
            )
        } else if (data.label === 'ID_TYPE') {
            return (
                <>
                    <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                        {findLabel(data.label)}
                    </Box>
                    <Select
                        value={selectedEIN}
                        fullWidth
                        sx={sx.selectBox}
                        size="small"
                        onChange={e => {
                            setSelectedEIN(e.target.value)
                            handleChange({
                                ...data,
                                userEnteredInformation: e.target.value,
                                isMatched: data.publicInformation === e.target.value,
                                isDataChanged: data.publicInformation !== e.target.value,
                            })
                        }}
                        displayEmpty
                    >
                        <MenuItem value="Employer ID Number (EIN)">Employer ID Number (EIN)</MenuItem>
                        <MenuItem value="Individual Tax ID Number (ITIN)">Individual Tax ID Number (ITIN)</MenuItem>
                        <MenuItem value="Social Security Number (SSN)">Social Security Number (SSN)</MenuItem>
                    </Select>
                </>
            )
        } else {
            return (
                <TextField
                    label={findLabel(data.label)}
                    multiline={data.type === 'textarea'}
                    sx={sx.textBox}
                    maxRows={4}
                    variant="outlined"
                    InputLabelProps={{ shrink: false }}
                    className="customInput bootstrapLabel customLabel"
                    size="small"
                    fullWidth
                    defaultValue={data.userEnteredInformation}
                    placeholder="No data found"
                    onKeyPress={findLabel(data.label) === 'Year Established' ? handleKeyPress : ''}
                    inputProps={{ maxLength: findLabel(data.label) === 'Year Established' ? '4' : '' }}
                    onChange={e =>
                        handleChange({
                            ...data,
                            userEnteredInformation: e.target.value,
                            isMatched: data.publicInformation === e.target.value,
                            isDataChanged: data.publicInformation !== e.target.value,
                        })
                    }
                />
            )
        }
    }

    return (
      <>
        <TableCell align="right">
          <Box display="flex" justifyContent="center">
            <RadioButton
              checked={data.isCorrect === null ? false : data.isCorrect}
              onChange={val => {
                setOpen(false)
                handleChange({
                  ...data,
                  isCorrect: val,
                  isDataChanged: true,
                  isMatched: data.publicInformation === val.target,
                })
              }}
              type="success"
            />
          </Box>
        </TableCell>
        <TableCell align="right">
          <Box display="flex" justifyContent="center">
            <RadioButton
              checked={data.isCorrect === null ? false : !data.isCorrect}
              onChange={val => {
                setOpenDisable(true)
                handleChange({
                  ...data,
                  isCorrect: false,
                  isDataChanged: true,
                  isMatched: data.publicInformation === val.target,
                })
              }}
              type="error"
            />
          </Box>
        </TableCell>
        <TableCell align="left" width="300px">
          {findDom()}
        </TableCell>
        <TableCell align="center">
          <Tooltip
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: '#0A78CD',
                },
              },
            }}
            title={<Typography variant="body2">{TooltipContent}</Typography>}
            open={open || openDisable}
          >
            <IconButton>
              <InfoOutlinedIcon fontSize="large" sx={{ color: '#0099FF' }} />
            </IconButton>
          </Tooltip>
        </TableCell>
      </>
    )
}
export default SelectionBox